import { render, staticRenderFns } from "./NumericField.vue?vue&type=template&id=af8d4b4e"
import script from "./NumericField.vue?vue&type=script&lang=js"
export * from "./NumericField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports